import { Reducer } from 'redux';
import { BASE_Action } from '../../Core/Redux/BaseAction';
import { ChangeShowOrHide, ChangeTitle, HeaderTickerAction } from '../Action/HeaderTickerAction';

export interface HearderTickerReducer {
    Title: string,
    Show: boolean
}

const initialState: HearderTickerReducer = {
    Title: "Default title",
    Show: true
}

export const HeaderTickerReducer:Reducer<HearderTickerReducer,HeaderTickerAction> = (state= initialState, action: HeaderTickerAction) => {
    switch (action.type) {
        case ChangeShowOrHide: {
            return {
                ...state,
                Show: action.Data
            };
        }
        case ChangeTitle: {
            return {
                ...state,
                Title: action.Data
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default HeaderTickerReducer;
